import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ContainerSwitch = styled.div`
  width: auto;
  height: 30px;

  gap: 8px;
  display: flex;
  align-items: center;
  margin-left: 0.3rem;

  @media (max-width: 790px) {
    margin-left: 0;
    justify-content: center;
  }
`;

export const SwitchContainer = styled.div`
  position: relative;

  width: 30px;
  height: 12px;
  padding: 0.125rem;
  
  display: flex;
  align-items: center;
  
  cursor: pointer;
  border-radius: 0.625rem;
  border: ${({ isOn }) => (isOn ? "none" : `1px solid  ${theme.colors.gray.Cinza_8}`)};
  background-color: ${({ isOn }) => (isOn ? "#2FBB693D" : theme.colors.gray.Cinza_12)};
`;

export const SwitchCircle = styled.div`
  width: 18px;
  height: 18px;
  left: ${({ isOn }) => (isOn ? "0.7rem" : "-0.25rem")};
    
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  transition: left 0.3s ease;
  
  border: ${({ isOn }) => (isOn ? "none" : `1px solid ${theme.colors.gray.Cinza_8}`)};
  background: ${({ isOn }) => (isOn ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_10)};
`;